import {$GET, $POST} from '../libs/http';

/**
 * @desc 查询新闻详情
 * @param {Object} params - 参数 
 * @return {Promise}
 */
export function fetchNewsDetail(params){
    return $GET('/api/v1/news', params)
}


// WEBPACK FOOTER //
// ./src/utils/services/news.js